import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Alert, CircularProgress, InputAdornment } from '@mui/material';
import { Auth } from 'aws-amplify';
import React, { useState } from 'react';

import {
  CardBody,
  FieldLabel,
  FieldWrapper,
  LoginCard,
  LogoImage,
  LogoWrapper,
  PageBackground,
  PageSubtitle,
  PageTitle,
  StyledInput,
  SubmitButton,
} from './style';

interface LoginPageProps {
  onLogin: () => void;
}

const ICON_COLOR = '#94a3b8';

export const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await Auth.signIn(`${username}@hekaglobal.com`, password);
      onLogin();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageBackground>
      <LoginCard>
        <CardBody>
          <LogoWrapper>
            <LogoImage src="/favicon.svg" alt="Heka logo" />
            <PageTitle variant="h5">Heka API Documentation</PageTitle>
            <PageSubtitle variant="body2">Sign in to access the API reference</PageSubtitle>
          </LogoWrapper>

          {error && <Alert severity="error" sx={{ mb: 2.5, fontFamily: "'Poppins', sans-serif" }}>{error}</Alert>}

          <form onSubmit={handleSubmit} noValidate>
            <FieldWrapper>
              <FieldLabel variant="caption">Username / Email</FieldLabel>
              <StyledInput
                type="text"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                placeholder="name@heka"
                startAdornment={
                  <InputAdornment position="start">
                    <AlternateEmailIcon sx={{ color: ICON_COLOR, fontSize: 18 }} />
                  </InputAdornment>
                }
              />
            </FieldWrapper>

            <FieldWrapper style={{ marginBottom: 24 }}>
              <FieldLabel variant="caption">Password</FieldLabel>
              <StyledInput
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                startAdornment={
                  <InputAdornment position="start">
                    <LockOutlinedIcon sx={{ color: ICON_COLOR, fontSize: 18 }} />
                  </InputAdornment>
                }
              />
            </FieldWrapper>

            <SubmitButton type="submit" fullWidth variant="contained" disabled={loading}>
              {loading ? <CircularProgress size={22} color="inherit" /> : 'Sign In'}
            </SubmitButton>
          </form>
        </CardBody>
      </LoginCard>
    </PageBackground>
  );
};
